export const BORDER_RADIUS_CORNERS = ['topLeft', 'topRight', 'bottomRight', 'bottomLeft'];

export function getUniformBorderRadiusValue(borderRadius) {
    if (typeof borderRadius === 'number') {
        return borderRadius;
    }

    if (!borderRadius) {
        return 0;
    }

    const values = BORDER_RADIUS_CORNERS.map((key) => borderRadius[key] ?? 0);
    return values.every((value) => value === values[0]) ? values[0] : values[0] ?? 0;
}

export function getBorderRadiusCorners(borderRadius) {
    if (typeof borderRadius === 'number') {
        return {
            topLeft: borderRadius,
            topRight: borderRadius,
            bottomRight: borderRadius,
            bottomLeft: borderRadius,
        };
    }

    return {
        topLeft: borderRadius?.topLeft ?? 0,
        topRight: borderRadius?.topRight ?? 0,
        bottomRight: borderRadius?.bottomRight ?? 0,
        bottomLeft: borderRadius?.bottomLeft ?? 0,
    };
}

export function getBorderRadiusValue(borderRadius) {
    if (borderRadius === null || borderRadius === undefined) {
        return undefined;
    }

    if (typeof borderRadius === 'number') {
        return borderRadius + 'px';
    }

    const corners = getBorderRadiusCorners(borderRadius);
    return corners.topLeft + 'px ' + corners.topRight + 'px ' + corners.bottomRight + 'px ' + corners.bottomLeft + 'px';
}
